<template>
  <v-avatar class="primary"
                size=30
                @click="pushRoute('Help')">
        <v-icon dark>help_outline</v-icon>
      </v-avatar>
</template>

<script>
export default {
  name: 'navigation-sidebar-bottom-help',
  components: {},
  data() {
    return {
      menu: false
    };
  },
  methods: {
    pushRoute(name) {
      this.$router.push({ name: name });
    }
  }
};
</script>

<style scoped>
.capitalize {
  text-transform: capitalize;
}
.v-avatar {
  cursor: pointer;
}
</style>




// WEBPACK FOOTER //
// src/components/commons/NavigationSidebarBottomHelp.vue